import TabButton from './TabButton';

export default TabButton;


// WEBPACK FOOTER //
// /src/components/UiComponents/TabButton/index.js